"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
Object.defineProperty(exports, "__esModule", { value: true });
var ServiceEndpointHelper_1 = require("../common/ServiceEndpointHelper");
var V1PollingHelper_1 = require("./V1PollingHelper");
var Constants_1 = require("../common/Constants");
var Poller = /** @class */ (function () {
    function Poller(ic3Info, onNewData, onError, callbackOnFailure) {
        this.isPolling = false;
        this._ic3Info = ic3Info;
        this._onNewData = onNewData;
        this._onError = onError;
        this.callbackOnFailure = callbackOnFailure;
    }
    Poller.prototype.start = function () {
        if (!this.isPolling) {
            this.isPolling = true;
            this.startPolling();
        }
        return Promise.resolve();
    };
    Poller.prototype.stop = function () {
        this.isPolling = false;
        return Promise.resolve();
    };
    Object.defineProperty(Poller.prototype, "onNewData", {
        get: function () {
            return this._onNewData;
        },
        set: function (input) {
            this._onNewData = input;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Poller.prototype, "onError", {
        get: function () {
            return this._onError;
        },
        set: function (input) {
            this._onError = input;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Poller.prototype, "setCallbackOnFailure", {
        set: function (input) {
            this.setCallbackOnFailure = input;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Poller.prototype, "ic3Info", {
        get: function () {
            return this._ic3Info;
        },
        set: function (input) {
            this._ic3Info = input;
        },
        enumerable: false,
        configurable: true
    });
    Poller.prototype.startPolling = function () {
        var _this = this;
        if (this.isPolling) {
            this.poll()
                .then(function (data) {
                if (_this.isPolling && _this._onNewData) {
                    _this._onNewData(data);
                }
            })
                .catch(function (e) {
                if (_this._onError) {
                    _this._onError(e);
                }
            })
                .then(function () {
                _this.startPolling();
            });
        }
    };
    Poller.prototype.poll = function () {
        var url = ServiceEndpointHelper_1.default.getV1PollUrl(this._ic3Info.RegionGtms, this._ic3Info.subscriptionId);
        return V1PollingHelper_1.default.poll(url, this._ic3Info.RegistrationToken, this.callbackOnEachRequestCompleted.bind(this));
    };
    Poller.prototype.callbackOnEachRequestCompleted = function (jqXHR) {
        this.callbackOnFailure(jqXHR, Constants_1.default.pollRequestLog);
    };
    return Poller;
}());
exports.default = Poller;
//# sourceMappingURL=Poller.js.map